var React = require('react');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');
var Loader = require('react-loader');
var moment = require('moment');
var DashboardWithDataMyGi = require('./layout/dashboardWithDataMyGi.jsx');
var DashboardWithoutDataMyGi = require('./layout/dashboardWithoutDataMyGi.jsx');

var DashboardMyGi = createReactClass({
    mixins: [PureRenderMixin],

    componentDidMount: function() {
        this.props.fetchTotalScoresIfNeeded(this.props.auth.token);
    },

    componentWillUnmount: function(){
        this.props.clearDashboard();
    },

    hasDataLoaded: function(){
        return !!(this.props.latestScore !== undefined && !this.props.dashboard.isFetching);
    },

    getContent: function(){
        var daysBeforeLatestSurvey = -1;

        var content = null;

        if(this.hasDataLoaded()){
            if(Object.keys(this.props.latestScore).length){
                daysBeforeLatestSurvey = moment().dayOfYear() - moment(this.props.latestScore.timeStamp).dayOfYear();
                if(Object.keys(this.props.latestNonZeroScore).length){
                    content = (
                        <DashboardWithDataMyGi
                            score={this.props.latestNonZeroScore}
                            latestTimeStamp={this.props.latestScore.timeStamp}
                            activeItems={this.props.dashboard.activeItems}
                            id2ItemScoresData={this.props.id2ItemScoresData}
                            daysBeforeLatestSurvey={daysBeforeLatestSurvey}
                            addActiveItem={this.props.addActiveItem}
                            removeActiveItem={this.props.removeActiveItem}
                            setActiveItems={this.props.setActiveItems}
                            isSnapShot={this.props.dashboard.isSnapShot}
                            clickTracking={this.props.recordDashboardClick} />
                    );
                }else{
                    content = (
                        <DashboardWithoutDataMyGi
                            items={this.props.dashboard.symptomList}
                            fakeItemScoresDataList={this.props.dashboard.fakeItemScoresDataListForZero}
                            daysBeforeLatestSurvey={daysBeforeLatestSurvey}
                            showModal={this.props.showModal}
                            clickTracking={this.props.recordDashboardClick} />
                    );
                }
            }else{
                content = (
                    <DashboardWithoutDataMyGi
                        isEmpty={true}
                        items={this.props.dashboard.symptomList}
                        fakeItemScoresDataList={this.props.dashboard.fakeItemScoresDataListForEmpty}
                        clickTracking={this.props.recordDashboardClick} />
                );
            }
        }

        return content;
    },

    render: function(){
        return (
            <div className="content-mygi content">
                <Loader loaded={this.hasDataLoaded()}>
                    {this.getContent()}
                </Loader>
            </div>
        )
    }
});

module.exports = DashboardMyGi;



// WEBPACK FOOTER //
// ./src/common/routes/dashboard/components/dashboardMyGi.jsx